import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';
import { FormFieldProps } from 'lib/forms/FormFieldProps';
import { getWidthClass } from 'lib/forms/FormFieldUtils';
import classNames from 'classnames';

export type FillerProps = Feature.EnterpriseWeb.Enterprise.Forms.Fields.Filler & FormFieldProps;

const Filler = (props: FillerProps): JSX.Element => {
  return (
    <div className={`relative mb-s hidden md:block ${classNames(getWidthClass(props))}`}></div>
  );
};

export default Filler;
